import { render, staticRenderFns } from "./VisualizarDocumentos.vue?vue&type=template&id=ca1db4b0"
import script from "./VisualizarDocumentos.vue?vue&type=script&lang=js"
export * from "./VisualizarDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports